import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen]   = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const [unread, setUnread]       = useState(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (user && user.status === 'approved') {
      API.get('/api/notifications/unread-count')
        .then(r => setUnread(r.data.count))
        .catch(() => {});
      const t = setInterval(() => {
        API.get('/api/notifications/unread-count')
          .then(r => setUnread(r.data.count))
          .catch(() => {});
      }, 60000);
      return () => clearInterval(t);
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container navbar-inner">
        {/* LOGO */}
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <div className="logo-icon">🪷</div>
          <div className="logo-text">
            <span className="logo-main">Suvaran Maran</span>
            <span className="logo-sub">Matrimony</span>
          </div>
        </Link>

        {/* DESKTOP NAV */}
        <ul className="navbar-links">
          <li><Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link></li>
          <li><Link to="/plan" className={isActive('/plan') ? 'active' : ''}>Plan</Link></li>
          <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link></li>
        </ul>

        {/* AUTH BUTTONS */}
        <div className="navbar-auth">
          {!user ? (
            <>
              <Link to="/login" className="btn btn-outline btn-sm">Login</Link>
              <Link to="/register" className="btn btn-gold btn-sm">Register Free</Link>
            </>
          ) : user.role === 'admin' ? (
            <>
              <Link to="/admin" className="btn btn-primary btn-sm">Admin Panel</Link>
              <button onClick={handleLogout} className="btn btn-outline btn-sm">Logout</button>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="btn btn-outline btn-sm dashboard-btn">
                Dashboard
                {unread > 0 && <span className="notif-badge">{unread}</span>}
              </Link>
              <button onClick={handleLogout} className="btn btn-primary btn-sm">Logout</button>
            </>
          )}
        </div>

        {/* MOBILE HAMBURGER */}
        <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
          <Link to="/plan" onClick={() => setMenuOpen(false)}>Plan</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
          {!user ? (
            <>
              <Link to="/login" className="btn btn-outline" onClick={() => setMenuOpen(false)}>Login</Link>
              <Link to="/register" className="btn btn-gold" onClick={() => setMenuOpen(false)}>Register Free</Link>
            </>
          ) : user.role === 'admin' ? (
            <>
              <Link to="/admin" className="btn btn-primary" onClick={() => setMenuOpen(false)}>Admin Panel</Link>
              <button onClick={handleLogout} className="btn btn-outline">Logout</button>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="btn btn-outline" onClick={() => setMenuOpen(false)}>
                Dashboard {unread > 0 && `(${unread})`}
              </Link>
              <button onClick={handleLogout} className="btn btn-primary">Logout</button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
